import React from 'react';

import persistentStore from './persistentStore.js';

const AppContext = {};

try {
    //If these succeed, we have local storage
    localStorage.setItem( "local_storage_test", "test" );
    localStorage.removeItem( "local_storage_test" );

    //We have local storage, replace our persistentStore
    AppContext.persistentStore = localStorage;
}catch(e) {
  console.log("no local storage using persistentStore");
    AppContext.persistentStore = persistentStore;
}

AppContext.possiblePlatforms = [
  'DAILYBREAK',
  'DEMO',
  'EMBED',
];

export default AppContext;


// WEBPACK FOOTER //
// ./public/pages/AppContext.jsx